/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import {
  Button, Dialog, DialogActions, DialogContent,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faXmark } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import { SelectTravelersList } from '../constants/options';
import Sidebar from '../components/quiz-sidebar';
import { API_URL, PYTHON_API_URL } from '../constants';
import { getLodging, getThingsToDo } from '../services/api';
import 'react-datepicker/dist/react-datepicker.css';

function CreateTrip() {
  const [city, setCity] = useState('');
  const [placeNames, setPlaceNames] = useState([]);
  const [lodging, setLodging] = useState([]);
  const [photoUrls, setPhotoUrls] = useState([]);
  const [lodgingPhotoUrls, setLodgingPhotoUrls] = useState([]);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [validationErrors, setValidationErrors] = useState({});
  const [cityName, setCityName] = useState('Boston');
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedLodgings, setSelectedLodgings] = useState([]);
  const navigate = useNavigate();
  const DEFAULT_DAYS = 3;

  const apiKey = useSelector((state) => state.data.mapKey);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (city) {
          getThingsToDo(city.label).then((data) => {
            setPlaceNames(data.placeNames);
            setPhotoUrls(data.photoUrls);
          });
        } else {
          setPlaceNames([]);
        }
      } catch (error) {
        console.error(error);
        throw error;
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [city]);

  // TESTING: uncomment to log updated placeNames and photoUrls
  useEffect(() => {
    // console.log('updated names', placeNames);
    // console.log('updated photos', photoUrls);
  }, [placeNames, photoUrls]);

  const SaveAITrip = async (TripData) => {
    setLoading(true);
    const docId = Date.now().toString();
    const user = JSON.parse(localStorage.getItem('user'));

    try {
      await axios.post(`${API_URL}/api/trips/create-trip`, {
        tripData: TripData,
        userSelection: formData,
        userEmail: user?.email,
        id: docId,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Save trip error:', error);
    }
  };

  const generateAITrip = async () => {
    // if ((formData?.numDays > 5 && !formData?.location) || !formData?.budget || !formData?.traveler) {
    //   return;
    // }
    try {
      const tripResponseUrl = new URL(`${PYTHON_API_URL}/v2/ai-generate/`);
      tripResponseUrl.searchParams.append('location', formData?.location?.label);
      tripResponseUrl.searchParams.append('numDays', formData?.numDays);
      tripResponseUrl.searchParams.append('traveler', formData?.traveler);
      tripResponseUrl.searchParams.append('budget', formData?.budget);
      tripResponseUrl.searchParams.append('food', formData?.food);
      tripResponseUrl.searchParams.append('lodging', formData?.lodging);
      tripResponseUrl.searchParams.append('transport', formData?.transport);
      selectedLodgings.forEach((lodgingOption) => tripResponseUrl.searchParams.append('preferredLodging', lodgingOption));
      selectedLocations.forEach((locationOption) => tripResponseUrl.searchParams.append('preferredThingToDo', locationOption));
      console.log(tripResponseUrl);
      const result = await axios.get(tripResponseUrl);
      const tripData = result?.data;
      console.log(tripData);
      setLoading(false);
      await SaveAITrip(tripData);
      navigate('/my-trips');
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Save trip error:', error);
    }
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      // Clear validation errors for the field
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: '',
      }));
      // Extract city name if location is changed
      if (name === 'location') {
        const [newCityName] = value.label.split(',');
        setCityName(newCityName);
      }
      // If startDate is changed, reset endDate
      if (name === 'startDate') {
        updatedData.endDate = null;
      }
      // If both startDate and endDate are selected, calculate numDays
      if (updatedData.startDate && updatedData.endDate) {
        const diffInTime = updatedData.endDate - updatedData.startDate;
        const numDays = Math.max(0, Math.ceil(diffInTime / (1000 * 60 * 60 * 24))) + 1; // Ensure at least 1 day
        updatedData.numDays = numDays;
      }
      if (name === 'public') {
        updatedData.public = value === 'Public';
      }
      return updatedData;
    });
  };

  const validateStep = () => {
    console.log('formData', formData);
    const errors = {};

    if (currentStep === 0) {
      if (!formData.location) {
        errors.location = 'Please select a location.';
      }
      if (!formData.traveler) {
        errors.traveler = 'Please select a traveler option.';
      }
      if (!formData.startDate) {
        errors.startDate = 'Please select a start date.';
      }
      if (!formData.endDate) {
        errors.endDate = 'Please select a start date.';
      }
    }
    if (currentStep === 1) {
      if (!formData.budget) {
        errors.budget = 'Please select a budget.';
      }
      if (!formData.transport) {
        errors.transport = 'Please select a transport option.';
      }
      if (!formData.food) {
        errors.food = 'Please select a food preference.';
      }
      if (!formData.lodging) {
        errors.lodging = 'Please select a lodging option.';
      }
    }
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handleBackClick = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const toggleLocationSelection = (location) => {
    setSelectedLocations((prevSelected) => {
      const updatedLocations = prevSelected.includes(location)
        ? prevSelected.filter((item) => item !== location)
        : [...prevSelected, location];

      // Update formData to reflect the selected locations
      setFormData((prevData) => ({
        ...prevData,
        selectedLocations: updatedLocations,
      }));

      return updatedLocations;
    });
  };

  const toggleLodgingSelection = (lodgingOption) => {
    setSelectedLodgings((prevSelected) => {
      const updatedLodgings = prevSelected.includes(lodgingOption)
        ? prevSelected.filter((item) => item !== lodgingOption)
        : [...prevSelected, lodgingOption];

      // Update formData to reflect the selected locations
      setFormData((prevData) => ({
        ...prevData,
        selectedLodgings: updatedLodgings,
      }));

      return updatedLodgings;
    });
  };

  const removeLocation = (location) => {
    setSelectedLocations((prevSelected) => prevSelected.filter((item) => item !== location));
  };

  const removeLodging = (lodgingOption) => {
    setSelectedLodgings((prevSelected) => prevSelected.filter((item) => item !== lodgingOption));
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <div className="content-container" style={{ width: '90%' }}>
            <h2 className="section-title">Basic Information</h2>
            <h3 className="section-description">Select any city you want to go (in the world!).
              If you plan to travel to several different cities in one trip, you can create multiple separate trips.
            </h3>
            <div className="quiz-page">
              <div className="question-container">
                <div className="question">
                  <h3>I want to go to</h3>
                  <GooglePlacesAutocomplete
                    apiKey={apiKey}
                    selectProps={{
                      value: city || null,
                      onChange: (value) => {
                        setCity(value);
                        handleInputChange('location', { label: value.label, place_id: value.value.place_id });
                      },
                      className: 'autocomplete-input',
                    }}
                    autocompletionRequest={{
                      types: ['(cities)'],
                    }}
                  />
                </div>
                <div className="error-container">
                  {validationErrors.location ? (
                    <div className="error">{validationErrors.location}</div>
                  ) : (
                    <div className="error-placeholder"> </div>
                  )}
                </div>
              </div>
              <div className="question-container">
                <div className="question" style={{ justifyContent: 'flex-start' }}>
                  <h3>I am traveling from</h3>
                  <DatePicker
                    key={`date-picker-${formData.startDate}-${formData.endDate}`}
                    onChange={(dates) => {
                      const [startDate, endDate] = dates;

                      // limit selection to 10 days (inclusive of both ends)
                      if (startDate && endDate) {
                        const diffTime = Math.abs(endDate - startDate);
                        const lengthDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
                        if (lengthDays > 10) {
                          alert('You can select a maximum of 10 days.');
                          return;
                        }
                      }
                      if (startDate) {
                        handleInputChange('startDate', startDate);
                      }
                      if (endDate) {
                        handleInputChange('endDate', endDate);
                      }
                      // handleInputChange('endDate', endDate);
                    }}
                    selected={formData.startDate}
                    startDate={formData.startDate}
                    endDate={formData.endDate}
                    selectsRange
                    inline
                    className="input-box"
                    placeholderText="Select start and end dates"
                    minDate={new Date()} // Optional: prevent selecting past dates
                  />
                </div>
                <div className="error-container">
                  {validationErrors.numDays ? (
                    <div className="error">{validationErrors.numDays}</div>
                  ) : (
                    <div className="error-placeholder"> </div>
                  )}
                </div>
              </div>
              <div className="question-container">
                <div className="question">
                  <h3>I’m traveling with</h3>
                  <div className="grid-custom">
                    {SelectTravelersList.map((item, index) => (
                      <button
                        key={index}
                        onClick={() => handleInputChange('traveler', item.people)}
                        className={`quiz-option ${formData?.traveler === item.people ? 'highlight-option' : ''}`}
                      >
                        {item.title}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="error-container">
                  {validationErrors.traveler ? (
                    <div className="error">{validationErrors.traveler}</div>
                  ) : (
                    <div className="error-placeholder"> </div>
                  )}
                </div>
              </div>
              <div className="question-container">
                <div className="question">
                  <h3>I want to make this trip</h3>
                  <div className="grid-custom">
                    {['Public', 'Private'].map((option) => (
                      <button
                        key={option}
                        onClick={() => handleInputChange('public', option)}
                        className={`quiz-option ${formData?.public === (option === 'Public') ? 'highlight-option' : ''}`}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 1:
        return (
          <div className="content-container" style={{ width: '90%' }}>
            <h2 className="section-title">Preferences</h2>
            <h3 className="section-description">
              Select some preferences for your trip (these will apply to only this trip),
              we will suggest a travel itinerary that takes into account your preferences.
            </h3>
            <div className="quiz-page">
              <div className="question-container">
                <div className="question">
                  <h3>My budget is</h3>
                  <div className="grid-custom">
                    {['Cheap', 'Moderate', 'Luxurious'].map((option) => (
                      <button
                        key={option}
                        onClick={() => handleInputChange('budget', option)}
                        className={`quiz-option ${formData?.budget === option ? 'highlight-option' : ''}`}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="error-container">
                  {validationErrors.budget ? (
                    <div className="error">{validationErrors.budget}</div>
                  ) : (
                    <div className="error-placeholder"> </div>
                  )}
                </div>
              </div>
              <div className="question-container">
                <div className="question">
                  <h3>I prefer to travel by</h3>
                  <div className="grid-custom">
                    {['Car', 'Public Transport', 'Bike'].map((option) => (
                      <button
                        key={option}
                        onClick={() => handleInputChange('transport', option)}
                        className={`quiz-option ${formData?.transport === option ? 'highlight-option' : ''}`}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="error-container">
                  {validationErrors.transport ? (
                    <div className="error">{validationErrors.transport}</div>
                  ) : (
                    <div className="error-placeholder"> </div>
                  )}
                </div>
              </div>
              <div className="question-container">
                <div className="question">
                  <h3>I like to eat</h3>
                  <div className="grid-custom">
                    {['Local Food', 'Fast Food', 'Fine Dining'].map((option) => (
                      <button
                        key={option}
                        onClick={() => handleInputChange('food', option)}
                        className={`quiz-option ${formData?.food === option ? 'highlight-option' : ''}`}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="error-container">
                  {validationErrors.food ? (
                    <div className="error">{validationErrors.food}</div>
                  ) : (
                    <div className="error-placeholder"> </div>
                  )}
                </div>
              </div>
              <div className="question-container">
                <div className="question">
                  <h3>I want to stay at a</h3>
                  <div className="grid-custom">
                    {['Hotel', 'Cabin'].map((option) => (
                      <button
                        key={option}
                        onClick={() => {
                          handleInputChange('lodging', option);
                        }}
                        className={`quiz-option ${formData?.lodging === option ? 'highlight-option' : ''}`}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="error-container">
                  {validationErrors.lodging ? (
                    <div className="error">{validationErrors.lodging}</div>
                  ) : (
                    <div className="error-placeholder"> </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="content-container" style={{ width: '90%' }}>
            <h2 className="section-title">In {cityName}, I want to visit...</h2>
            <h3 className="section-description">
              Put down some tourist attractions you want to visit, we will use these locations as a basis of your travel itinerary.
              Due to time constraints, you may not get to visit all the places you selected, but we’ll try our best!
            </h3>
            {loading ? (
              <p>Loading places...</p>
            ) : (
              <div className="row_container" style={{ justifyContent: 'space-between', marginTop: '20px' }}>
                {/* search location box */}
                <div className="column_container">
                  <div className="search_location">
                    <div className="search_bar">
                      <h3 className="text_gray">Search Location</h3>
                      <div className="row_container">
                        <GooglePlacesAutocomplete
                          apiKey={apiKey}
                          selectProps={{
                            value: null,
                            onChange: (value) => {
                              setSelectedLocations((prev) => [...prev, value.label.split(',')[0].trim()]);
                            },
                            className: 'autocomplete-input',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row_container_scroll" style={{ flexWrap: 'wrap', flex: '1 1 calc(33.333% - 20px)' }}>
                    {placeNames.map((name, index) => (
                      <div
                        key={index}
                        onClick={() => toggleLocationSelection(name)}
                        className={`location_image_small ${selectedLocations.includes(name) ? 'selected' : ''}`}
                      >
                        {photoUrls[index] ? (
                          <>
                            <img className="location_image" src={photoUrls[index]} alt={name} />
                            <div className="gradient_overlay" />
                            <div className="location_name">{name}</div>
                          </>
                        ) : (
                          <div className="no-image-text">{name}</div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Preferred Locations */}
                <div className="column_container" style={{ width: '25%' }}>
                  <div className="preferred_locations">
                    <h3 className="text_gray">Preferred Locations</h3>
                    <div className="preferred-locations-scroll">
                      {selectedLocations.map((location, index) => (
                        <div key={index} className="option_box_deletable">
                          <div>{location}</div>
                          <FontAwesomeIcon icon={faXmark} className="delete-icon" onClick={() => removeLocation(location)} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      case 3:
        return (
          <div className="content-container" style={{ width: '90%' }}>
            <h2 className="section-title">In {cityName}, I want to stay at...</h2>
            <h3 className="section-description">
              Put down some lodgings you might be interested in, we will try to choose from one of these
              while generating your travel itinerary while taking into account the distance between your lodging and the locations you want to visit.
            </h3>
            {loading ? (
              <p>Loading lodgings...</p>
            ) : (
              <div className="row_container" style={{ justifyContent: 'space-between', marginTop: '20px' }}>
                {/* search lodging box */}
                <div className="column_container">
                  <div className="search_location">
                    <div className="search_bar">
                      <h3 className="text_gray">Search Lodging</h3>
                      <div className="row_container">
                        <GooglePlacesAutocomplete
                          apiKey={apiKey}
                          selectProps={{
                            value: null,
                            onChange: (value) => {
                              setSelectedLodgings((prev) => [...prev, value.label.split(',')[0].trim()]);
                            },
                            className: 'autocomplete-input',
                          }}
                          autocompletionRequest={{
                            types: ['lodging'],
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* popular lodgings */}
                  <div className="popular_locations">
                    <h3 className="text_gray">Popular Lodgings</h3>
                    <div className="row_container_scroll" style={{ flexWrap: 'wrap', flex: '1 1 calc(33.333% - 20px)' }}>
                      {lodging.map((name, index) => (
                        <div
                          key={index}
                          onClick={() => toggleLodgingSelection(name)}
                          className={`location_image_small ${selectedLodgings.includes(name) ? 'selected' : ''}`}
                        >
                          {lodgingPhotoUrls[index] ? (
                            <>
                              <img className="location_image" src={lodgingPhotoUrls[index]} alt={name} />
                              <div className="gradient_overlay" />
                              <div className="location_name">{name}</div>
                            </>
                          ) : (
                            <div className="no-image-text">{name}</div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* Preferred Lodgings */}
                <div className="column_container" style={{ width: '25%' }}>
                  <div className="preferred_locations">
                    <h3 className="text_gray">Preferred Lodgings</h3>
                    <div className="preferred-locations-scroll">
                      {selectedLodgings.map((location, index) => (
                        <div key={index} className="option_box_deletable">
                          <div>{location}</div>
                          <FontAwesomeIcon icon={faXmark} className="delete-icon" onClick={() => removeLodging(location)} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  const handleDialogClose = () => {
    navigate(-1);
  };

  const handleSidebarClick = (step) => {
    if (step < currentStep || validateStep()) {
      setCurrentStep(step);
    }
  };

  const isStepValid = (step) => {
    const errors = {};

    if (step === 0) {
      if (!formData.location) {
        errors.location = 'Please select a location.';
      }
      if (!formData.traveler) {
        errors.traveler = 'Please select a traveler option.';
      }
      if (!formData.startDate) {
        errors.startDate = 'Please select a start date.';
      }
      if (!formData.endDate) {
        errors.endDate = 'Please select a start date.';
      }
    }
    if (step === 1) {
      if (!formData.budget) {
        errors.budget = 'Please select a budget.';
      }
      if (!formData.transport) {
        errors.transport = 'Please select a transport option.';
      }
      if (!formData.food) {
        errors.food = 'Please select a food preference.';
      }
      if (!formData.lodging) {
        errors.lodging = 'Please select a lodging option.';
      }
    }
    return Object.keys(errors).length === 0;
  };

  useEffect(
    () => {
      handleInputChange('numDays', DEFAULT_DAYS);
    },
    [],
  );

  return (
    <Dialog fullWidth maxWidth="90vh" open onClose={handleDialogClose}>
      <DialogActions>
        <Button onClick={handleDialogClose}>
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </DialogActions>
      <DialogContent className="quiz-flex">
        <Sidebar currentStep={currentStep} setCurrentStep={handleSidebarClick} isStepValid={isStepValid} />
        <div className="form-container">
          {renderStepContent()}
          <div className="content-container" style={{ width: '90%' }}>
            {currentStep !== 0 && (
              <button
                className="next-button"
                onClick={handleBackClick}
              >
                {currentStep === 0 ? '' : 'Back'}
              </button>
            )}
            <button
              className="next-button"
              onClick={() => {
                if (currentStep === 3) {
                  generateAITrip();
                  return;
                } if (currentStep === 2) {
                  getLodging(cityName, formData.budget, formData.lodging).then((data) => {
                    setLodging(data.placeNames);
                    setLodgingPhotoUrls(data.photoUrls);
                  });
                  handleNext();
                } else {
                  handleNext();
                }
              }}
            >
              {currentStep === 3 ? 'Create Trip!' : 'Next'}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CreateTrip;
